package game.entity

import game.Game
import game.Room
import game.Weapon

enum class PotLevel(val spriteId: String, val strenght: Int) {
    Level1(
        "pot-1",
        1
    ),
    Level2(
        "pot-2",
        2
    ),
}

class Pot(val level: PotLevel) : Entity() {
    override fun onInit(game: Game, room: Room) {
        sprite = game.getSpriteById(level.spriteId)
    }

    override fun onAttacked(game: Game, weapon: Weapon) {
        if (game.player.weapon.damage >= level.strenght) {
            killMe(game)
        }
    }

    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        if (game.player.weapon.damage >= level.strenght) {
            game.message = game.text("Message_PotHit")
        } else {
            game.message = game.text("Message_Pot")
        }

        return false
    }
}